import React from "react";
import { Component } from "react";
import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
import { getBoundingClientRect } from "../../utils/functions";
import { checkTranslation, translate } from "../../utils/useful";
import LoaderButton from "../LoaderButton";
import CardBuilder from "./CardBuilder";
import HttpServices from "../../utils/Http.services";
import ButtonAnimated from "../buttons/ButtonAnimated";

class CustomizeFields extends Component {

  state = {
    characters: [],
    search: "",
  };

  componentDidMount() {
    // console.log('*custOMIZEFIELDSS', this.props.page)
    let fields = []
    let headers = JSON.parse(JSON.stringify(this.props.headers))
    headers?.map((element) => {
      fields.push({
        // id: element.id,
        key: element.key,
        type: element.type,
        information: element.information,
        showMain: (element.showMain == undefined || element.showMain == true) ? true : false,
      })
    })
    this.setState({ characters: fields });
  }

  onDragEnd = (result) => {
    let items = Array.from(this.state.characters);
    let [reorderItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderItem);
    this.setState({ characters: items }, () => {
    });
  };

  searchInput = (e) => {
    this.setState({ search: e.target.value }, () => {
      this.filterHandler();
    });
  };

  changeHide = (data, index) => {
    let characters = this.state.characters
    if (characters[index].showMain == undefined) {
      characters[index].showMain = true
    }
    characters[index].showMain = !characters[index].showMain
    this.setState({ characters })
  }

  submitInfo = () => {
    let data = { _id: this.props.page._id, view: this.props.view?.id, }
    // console.log('this.props.view90', this.props.view)
    data.fields = this.state.characters
    data.setting = 'customized'
    this.setState({ isLoadingPost: true })
    // console.log('data.fields', data.fields)
    HttpServices.request('updateFieldsView', data, (fetchResult, fetchError) => {
      this.setState({ isLoadingPost: false })
      if (fetchError) {
        this.props.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
      }
      // if (this.props.changeValue) {
      //   this.props.changeValue(item)
      // }
      if (fetchResult.info) {
        // console.log('fetchResult.info.views', fetchResult.info.views)
        this.props.setViews(fetchResult.info.views)
      }
      this.props.closeSide('customizeFieldsSide')
    })
  }

  filterHandler = () => {
    let fields = [...this.props.page.fields];
    let temp = [];
    for (let i = 0; i < fields.length; i++) {
      let content = fields[i];
      if (content.information.label.toLowerCase().includes(this.state.search.toLowerCase())) {
        temp.push(content);
      }
    }
    this.setState({ characters: temp });
  };

  close = () => {
    this.props.closeSide('customizeFieldsSide')
  }

  render() {
    return (
      <div ref={el => this.scrollContainer = el} className="w-100 h-100  " style={{}}>
        {/* <div className="flexcb px-2 py-1" style={{ position: 'sticky', top: 0, zIndex: 1, boxShadow: '0px 0px 30px #10101010', borderBottom: '1px solid #f6f6f6', background: this.props.background ?? 'linear-gradient(to right, #fff , #fff)', backgroundColor: '#fff' }}>
          <p className="text-bold py-1 px-2">{translate('Customize Card')}</p>
        </div> */}
        <div className='flexcb  position-sticky top-0 w-100' style={{ padding: '12px 14px', background: this.props.colors ? this.props.colors.background : 'linear-gradient(90deg, #fff, #fff)', zIndex: 2, borderBottom: '1px solid #eee', height: '60px' }}>
          <div className='flexc'>
            {this.state.backbtn == true &&
              <button onClick={this.BackStage}>
                <img width={18} className='mrd-2 flexcc invert' src='/assets/icons/arrow-left-white.svg' />
              </button>
            }
            <p className=' font-size-14 text-semibold' style={{ color: this.props.colors?.textColor ?? '#fff' }}>{translate('Customize Fields')}</p>
          </div>
          <div className="flexc">
            <div className="px-1">
              <ButtonAnimated
                // iconwidth='24px'
                onClick={() => { this.close() }}
                title={translate('Cancel')}
                // icon='/assets/icons/plus-white.svg'
                textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                isLoading={this.state.isLoadingPost}
                bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                invert={!this.props.colors?.iconInvert}

                width={'100%'}
              />
            </div>
            <ButtonAnimated
              iconwidth='24px'
              onClick={this.state.isLoadingPost ? () => { } : () => { this.submitInfo() }}
              title={translate('Submit')}
              icon='/assets/icons/plus-white.svg'
              textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
              isLoading={this.state.isLoadingPost}
              bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
              invert={!this.props.colors?.iconInvert}

              width={'100%'}
            />
          </div>
          {/* {this.state.backbtn == true &&
            <LoaderButton
              onClick={this.addField}
              isLoading={this.state.isLoadingPost}
              text={translate('Submit')}
              // type={"Oval"}
              className={"text-bold text-small text-center flexcc w-100 br-20 py-1  "}
              background={this.props.colors?.background}
              width={20}
              height={20}
              color={this.props.colors?.textColor}
            />
          } */}
        </div>
        <div className='scroll-no-scrollbar' style={{ height: 'calc(100% - 60px)' }}>
          {/* <div className="pt-3 pb-4" style={{ backgroundColor: '#f4f4f4' }}>
            <div className="px-4  mb-2">
              <p className="text-semibold ">Preview</p>
            </div>
            <CardBuilder
              header={this.props.page.fields}
              functionsHandler={this.props.functionsHandler}
              view={this.props.view}
            />
          </div> */}
          <div className="px-2">
            {/* <div className="w-100 mt-2" style={{}}>
              <div className="flexcb p-2" style={{ fontSize: "10px" }}>
                <div className="text-small text-semibold" style={{}}>
                  <p>{translate('Cover field')}</p>
                </div>
                <div className="flexcc" >
                  <div className="flexc">
                    <p>Crop</p>
                  </div>
                  <div className="flexc">
                    <label class="switch m-1">
                      <input type="checkbox" />
                      <span class="slider round"></span>
                    </label>
                  </div>
                  <div className="flexc">
                    <p>Fit</p>
                  </div>
                </div>
              </div>
              {this.state.characters.map((item, index) => {
                if (item.type == 'VideoInput' || item.type == 'ImageInput')
                  return (
                    <div className="fields-box w-100">
                      <div className="fields flexcb p-2 w-100" style={{ transform: "none" }} >
                        <div className="flexc">
                          // <label class="switch">
                            // <input type="checkbox" />
                            // <span class="slider round"></span>
                          // </label>
                          <label className=" d-flex" style={{ paddingBottom: 5 }} onClick={() => this.radioHandler(item.key)}>
                            <input className='mrd-2' type="radio" checked={this.state.selected == item.key} />
                            <p className="text-smaller" key={index}>{checkTranslation(item?.information?.label)} </p>
                            // <p className="text-smallest color-gray-1" key={index}>{item?.type} </p>
                          </label>
                          // <p className="text-smaller mx-2">{item?.information?.label}</p>
                        </div>
                        // <div style={{ width: "15px" }} >
                          // <img className="" style={{ opacity: 0.8 }} src="/assets/icons/drag-and-drop.svg" width="13px" />
                        // </div>
                      </div>
                    </div>
                  )
              })}
              <div className=""></div>
            </div> */}
            <div className="text-small text-semibold px-2 pt-2 pb-1" style={{}}>
              <p>{translate('Fields to show')}</p>
            </div>
            <div className="px-1 py-1">
              <div className="fields-search flexc p-1 w-100 br-4 mt-1" style={{ backgroundColor: '#f6f6f6' }}>
                <img src="/assets/icons/gantt/search.svg" className="mld-1" height={12} alt="" />
                <input value={this.state.search} onChange={(e) => this.searchInput(e)} type="text" name="name" className="fields-search text-smaller p-1" style={{ backgroundColor: 'transparent', borderBottom: "none", width: "100%" }} placeholder={translate("Find a field")} />
              </div>
            </div>
            <div style={{ position: "fixed", top: "0", left: "0" }} ref={(el) => (this.setPositionDiv = el)}></div>
            <div className="flexc scroll-no-scrollbar aa" style={{ flexDirection: "column", alignItems: "flex-start", backgroundColor: "#fff" }}>
              <DragDropContext onDragEnd={(result) => this.onDragEnd(result)}>
                <Droppable droppableId="droppable">
                  {(provided) => (
                    <div className="w-100" style={{ transform: "none" }} {...provided.droppableProps} ref={provided.innerRef}>
                      {Array.isArray(this.state.characters) && this.state.characters.map((item, index) => {
                        // console.log(item)
                        if (item.type != "StaticText") {
                          return (
                            <Draggable key={item.key} draggableId={item.key} index={index}>
                              {(provided, snapshot) => {
                                if (snapshot.isDragging) {
                                  if (!provided.draggableProps) {
                                    provided.draggableProps = { style: { boxShadow: "0px 0px 30px #10101090", zIndex: "10" } };
                                  }
                                  let bound = getBoundingClientRect(this.setPositionDiv);
                                  // let scrollTop = this.scrollContainer.scrollTop
                                  const offset = { x: bound.left, y: bound.top };
                                  let x = (provided.draggableProps?.style?.left ?? 0) - offset.x;
                                  let y = (provided.draggableProps?.style?.top ?? 0) - offset.y;
                                  // y = y - scrollTop
                                  provided.draggableProps.style.left = x + 'px';
                                  provided.draggableProps.style.top = y + 'px';
                                  provided.draggableProps.style.boxShadow = "0px 0px 10px #10101020";
                                  provided.draggableProps.style.zIndex = "10";
                                }
                                return (
                                  <div className="fields-box w-100">
                                    <div className="fields flexcb br-6 p-2" style={{ transform: "none" }} ref={provided.innerRef} {...provided.draggableProps}>
                                      <div className="flexc">
                                        <label class="switch">
                                          <input type="checkbox" checked={item?.showMain == undefined || item?.showMain} onChange={() => this.changeHide(item, index)} />
                                          <span class="slider round"></span>
                                        </label>
                                        {/* <Switch onChange={this.handleChange} checked={this.state.checked} /> */}
                                        {/* <img src={item.src} className="mx-1" style={{ width: "10px" }} /> */}
                                        <p className="text-smaller mx-2">{checkTranslation(item?.information?.label)}</p>
                                      </div>
                                      <div className="flexc">
                                        <div style={{ width: "15px" }} className="mx-1 cursor-poiner">
                                          <img className="" style={{ opacity: 0.8 }} src="/assets/icons/useful/settings.png" width="13px" alt="" />
                                        </div>
                                        <div style={{ width: "15px" }} {...provided.dragHandleProps}>
                                          <img className="" style={{ opacity: 0.8 }} src="/assets/icons/drag-and-drop.svg" width="13px" alt="" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }}
                            </Draggable>
                          );
                        }
                      })}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
            {/* <div className="fields-buttons flexcb p-2 pt-1 w-100" style={{}}>
            <button className="fields-button text-smaller w-100 mrd-1" onClick={() => this.hideAllHandler()}>
              Hide all
            </button>
            <button className="fields-button text-smaller w-100 mld-1" onClick={() => this.showAllHandler()}>
              Show all
            </button>
          </div> */}
          </div>
        </div>
      </div>
    );
  }
}

export default CustomizeFields;